import { Divider, Typography } from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import { Toolbox } from '~/plugins/toolbox/shared'

type Props = {
  date: dayjs.Dayjs
}

export const RenderDateSplitter: React.FC<Props> = ({ date }) => {
  const datePart = Toolbox.Date.toAsanaStyle(date.toDate())

  return (
    <>
      <Divider>
        <Typography.Text type="secondary">{datePart}</Typography.Text>
      </Divider>
    </>
  )
}
